import React, { Component } from 'react'
import { Grid } from '@softwaredev_cegeka/stix-core'
import './contentHeader.scss'

class ContentHeader extends Component {
    render() {
        const { children } = this.props
        return (
            <div className="content-top">
                <Grid.Container fluid={'xl'}>{children}</Grid.Container>
            </div>
        )
    }
}

export default ContentHeader
